import { LoaderCircle } from "@/components/ui/icons";
import MicrosoftIcon from "@/components/ui/icons/microsoft-icon";
import { Skeleton } from "@/components/ui/skeleton";
import { OAuthStrategy } from "@clerk/types";

export function GoogleButton({
  onClick,
  loading,
  children,
}: {
  onClick: (strategy: OAuthStrategy) => void;
  loading: boolean;
  children: React.ReactNode;
}) {
  return (
    <button
      onClick={() => onClick("oauth_google")}
      className="flex w-full cursor-pointer items-center justify-center gap-1.5 rounded-lg border p-2.5 text-sm font-medium shadow-xs transition hover:shadow-md"
    >
      {loading ? (
        <LoaderCircle className="size-4 animate-spin" />
      ) : (
        <>
          <GoogleIcon />
          {children}
        </>
      )}
    </button>
  );
}

export function MicrosoftButton({
  onClick,
  loading,
  children,
}: {
  onClick: (strategy: OAuthStrategy) => void;
  loading: boolean;
  children: React.ReactNode;
}) {
  return (
    <button
      onClick={() => onClick("oauth_microsoft")}
      className="flex w-full cursor-pointer items-center justify-center gap-1.5 rounded-lg border p-2.5 text-sm font-medium shadow-xs transition hover:shadow-md"
    >
      {loading ? (
        <LoaderCircle className="size-4 animate-spin" />
      ) : (
        <>
          <MicrosoftIcon />
          {children}
        </>
      )}
    </button>
  );
}

export function OauthButtonSkeleton() {
  return <Skeleton className="h-10 w-full rounded-lg" />;
}

function GoogleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <g clipPath="url(#clip0_534_13025)">
        <path
          d="M8.75 7.04492V10.1431H13.0554C12.8664 11.1395 12.299 11.9831 11.4481 12.5504L14.0445 14.565C15.5572 13.1686 16.43 11.1177 16.43 8.68136C16.43 8.1141 16.3791 7.5686 16.2845 7.04501L8.75 7.04492Z"
          fill="#4285F4"
        />
        <path
          d="M4.26625 10.0225L3.68067 10.4707L1.60791 12.0852C2.92427 14.6961 5.62225 16.4998 8.7495 16.4998C10.9094 16.4998 12.7203 15.787 14.044 14.5653L11.4476 12.5507C10.7349 13.0307 9.82582 13.3216 8.7495 13.3216C6.66951 13.3216 4.90229 11.918 4.26952 10.0271L4.26625 10.0225Z"
          fill="#34A853"
        />
        <path
          d="M1.60812 4.91406C1.06269 5.99038 0.75 7.20494 0.75 8.49947C0.75 9.79399 1.06269 11.0086 1.60812 12.0849C1.60812 12.0921 4.26998 10.0194 4.26998 10.0194C4.10998 9.53942 4.01541 9.03036 4.01541 8.49939C4.01541 7.96841 4.10998 7.45935 4.26998 6.97935L1.60812 4.91406Z"
          fill="#FBBC05"
        />
        <path
          d="M8.74966 3.68545C9.92786 3.68545 10.9751 4.09271 11.8115 4.87818L14.1024 2.5873C12.7133 1.29278 10.9097 0.5 8.74966 0.5C5.62242 0.5 2.92427 2.29636 1.60791 4.91455L4.26969 6.98001C4.90238 5.08908 6.66968 3.68545 8.74966 3.68545Z"
          fill="#EA4335"
        />
      </g>
      <defs>
        <clipPath id="clip0_534_13025">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.75 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
